<template>
  <div v-if="!isLoading" class="columns is-multiline">
    <div class="column is-half" v-for="(question, index) in questions" :key="index">
      <question-box :data="question" />
    </div>
  </div>
  <loading-content v-else />
</template>

<script>
import API from '@/api'
import QuestionBox from './QuestionBox'
import LoadingContent from './LoadingContent'

export default {
  name: 'LatestQuestions',
  components: {
    QuestionBox,
    LoadingContent
  },
  data () {
    return {
      isLoading: true,
      questions: []
    }
  },
  mounted () {
    this.isLoading = true
    API.questions.index({
      order_by: 'views;desc',
      take: 10
    }, questions => {
      this.questions = questions
      this.isLoading = false
    })
  }
}
</script>
